<template>
  <accordion-item-fi
    v-if="approvals"
    ref="accordionItem"
    :class="{
      'accordion-document-downloads-fi': true,
      'accordion-document-downloads-fi--no-hierarchy': !enableGroupedListView,
    }"
    header-tag="h3"
    ignore-others
    scroll-to
    @accordion-item-toggle="accordionToggled = !accordionToggled"
  >
    <template #header>
      {{ $dict.get('product-Catalog.Accordions.Document-Downloads.Label') }}
    </template>
    <template #content="{ isOpen }">
      <grid-columns-fi
        :columns="12"
        grid-class="lg:fi-grid-cols-10"
      >
        <div class="fi-col-span-12 lg:fi-col-span-10">
          <template v-if="enableCategoryTabs">
            <tab-navigation-fi
              :tab-navigation="tabNavigation"
              :refresh-tabs="accordionToggled"
              :is-slider="true"
              :line-hidden="true"
              :init-id="initTab"
            >
              <template
                v-for="item in tabNavigation"
                :key="item.id"
                #[getTabName(item.id)]
              >
                <div class="accordion-document-downloads-fi__approval-list">
                  <document-download-items-fi
                    :documents="item.documents"
                    :is-focusable="isOpen"
                    theme="category-tabs"
                  />
                </div>
              </template>
            </tab-navigation-fi>
          </template>
          <!-- XXX Remove after the product data and it's interface has been updated. Unwrap tab navigation above -->
          <template v-else>
            <div class="accordion-document-downloads-fi__approval-list">
              <document-download-items-fi
                :documents="approvals"
                :is-focusable="isOpen"
              />
            </div>
          </template>
        </div>
      </grid-columns-fi>
    </template>
  </accordion-item-fi>
</template>

<script>
import { AccordionItemFi } from 'atoms';

import DocumentDownloadItemsFi from '@/components/document-download/DocumentDownloadItemsFi.vue';
import GridColumnsFi from '@/components/grid-fi/GridColumnsFi.vue';
import TabNavigationFi from '@/components/tab-navigation-fi/TabNavigationFi.vue';

export default {
  name: 'AccordionDocumentDownloadsFi',
  components: {
    GridColumnsFi,
    AccordionItemFi,
    TabNavigationFi,
    DocumentDownloadItemsFi,
  },
  inject: ['fields'],
  props: {
    catalogData: {
      type: Object,
      default: () => ({}),
    },
    tabHash: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      accordionToggled: false,
      initTab: 0,
    };
  },
  computed: {
    enableCategoryTabs() {
      return this.fields?.enableDocumentTabs?.value;
    },
    enableGroupedListView() {
      return Boolean(this.fields.enableGroupedListView?.value);
    },
    approvals() {
      if (!this.catalogData?.Documents) {
        return null;
      }

      let approvals = [];

      const catalogApprovals = this.catalogData.Documents.Approvals;
      const catalogDocuments = this.catalogData.Documents.AdditionalDocuments;

      if (catalogApprovals) {
        approvals.push(...catalogApprovals);
      }
      if (catalogDocuments) {
        approvals.push(...catalogDocuments);
      }

      if (!approvals.length) {
        return null;
      }

      if (this.enableGroupedListView) {
        const isChild = new Set();
        approvals = approvals.map((approval) => {
          const childIds = approval.ChildDocumentIds;

          if (childIds && childIds.length > 0) {
            const children = [];

            childIds.forEach((id) => {
              const childData = approvals.find((a) => a.DocumentId === id && a.ParentDocumentId);

              if (childData) {
                children.push(childData);
                isChild.add(id);
              }
            });

            const sortedChildren = children.sort(
              (a, b) => new Date(b.ValidFrom) - new Date(a.ValidFrom),
            );

            return {
              ...approval,
              Subitems: sortedChildren,
            };
          } else {
            return approval;
          }
        });

        return approvals.filter((a) => !isChild.has(a.DocumentId));
      }
      return approvals;
    },
    tabNavigation() {
      const groups = {};
      let id = 0;
      this.approvals.forEach((catalogDocument) => {
        const group =
          catalogDocument.Group?.Value || this.$dict.get('product-Catalog.No-Document-Group');

        if (groups[group]) {
          groups[group].documents.push(catalogDocument);
          return;
        }

        groups[group] = {
          id,
          text: group,
          documents: [catalogDocument],
          rank: catalogDocument.Group?.GroupRank,
          type: catalogDocument.Type,
        };
        id += 1;
      });
      const sortedGroups = Object.values(groups).sort((a, b) => a.rank - b.rank);
      sortedGroups.forEach((group) =>
        group.documents.sort((a, b) => a.DocumentRank - b.DocumentRank),
      );
      return sortedGroups;
    },
  },
  methods: {
    getTabName(id) {
      return `tab-content-${id}`;
    },
    openAccordion() {
      if (this.tabHash) {
        let tab = null;
        if (this.tabHash === 'etas-and-dops') {
          tab = this.tabNavigation.find(
            (el) =>
              el.type === 'ETA - European Technical Assessment' ||
              el.type === 'DOP - Declaration of Performance',
          );
        } else if (this.tabHash === 'safety-data-sheets') {
          tab = this.tabNavigation.find((el) => el.type === 'Safety Datasheet');
        } else if (this.tabHash === 'sustainability') {
          tab = this.tabNavigation.find((el) => el.type === 'Environmental Product Declaration');
        }
        this.initTab = tab?.id || 0;
      }

      this.$refs.accordionItem.toggleAccordion();
    },
  },
};
</script>

<style src="./accordion-document-downloads-fi-unscoped" />

<style scoped src="./accordion-document-downloads-fi" />
